import { useEffect } from 'react';
import { useMachineStore } from '@/store/store';

/**
 * usePhoneBLEConnection — BLE IPC olaylarını dinleyip Zustand store'unu günceller.
 *
 * App.tsx'te bir kez mount edilir. Electron preload.js üzerinden
 * main process'teki PhoneBLEConnection'dan gelen olayları yakalar:
 *
 *   phoneble:connect      → phoneBLEConnected = true, phoneBLEAddress = address
 *   phoneble:disconnect   → phoneBLEConnected = false, phoneBLEAddress = null
 *   phoneble:advertising  → phoneBLEAdvertising = active
 *   phoneble:file-received → lastBLEFile = { fileName, filePath }
 *
 * Electron olmayan ortamda (web tarayıcısı vb.) sessizce hiçbir şey yapmaz.
 */
export function usePhoneBLEConnection(): void {
  const setPhoneBLEConnected = useMachineStore((s) => s.setPhoneBLEConnected);
  const setPhoneBLEAdvertising = useMachineStore((s) => s.setPhoneBLEAdvertising);
  const setLastBLEFile = useMachineStore((s) => s.setLastBLEFile);

  useEffect(() => {
    const api = window.electronAPI?.phoneBLE;
    if (!api) return; // Electron dışında veya preload yüklenmemişse çık

    api.onConnect(({ address }) => {
      setPhoneBLEConnected(true, address);
      console.log('[BLE UI] Phone connected:', address);
    });

    api.onDisconnect(() => {
      setPhoneBLEConnected(false);
      console.log('[BLE UI] Phone disconnected');
    });

    api.onAdvertising(({ active }) => {
      setPhoneBLEAdvertising(active);
    });

    api.onFileReceived((data) => {
      setLastBLEFile(data);
      console.log('[BLE UI] File received:', data.fileName);
    });

    return () => {
      api.removeAllListeners();
    };
  }, [setPhoneBLEConnected, setPhoneBLEAdvertising, setLastBLEFile]);
}
